(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homesome-help-center"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('homesome-help-center')) {
    customElements.define(
      'homesome-help-center',
      class extends HTMLElement {}
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-help-search]').forEach((input) => {
      const section = input.closest('.homesome-help');
      if (!section) return;

      const items = Array.from(section.querySelectorAll('[data-help-item]'));
      const groups = Array.from(section.querySelectorAll('[data-help-group]'));
      const noResults = section.querySelector('[data-help-no-results]');

      const filterTopics = () => {
        const query = input.value.trim().toLowerCase();
        let visibleCount = 0;

        items.forEach((item) => {
          const haystack = ((item.dataset.search || '') + ' ' + item.textContent).toLowerCase();
          const match = !query || haystack.includes(query);
          item.hidden = !match;
          if (match) visibleCount += 1;
        });

        groups.forEach((group) => {
          const visibleItems = Array.from(group.querySelectorAll('[data-help-item]')).some((item) => !item.hidden);
          group.hidden = !visibleItems;
        });

        if (noResults) noResults.hidden = visibleCount !== 0;
      };

      input.addEventListener('input', filterTopics);
    });

    document.querySelectorAll('[data-chat-placeholder]').forEach((button) => {
      button.addEventListener('click', () => {
        const card = button.closest('.homesome-help__contact-card');
        const message = card?.querySelector('[data-chat-message]');
        if (message) message.hidden = false;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homesome-new-arrivals-placeholder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('homesome-placeholder-carousel')) {
    customElements.define(
      'homesome-placeholder-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.previousButton = this.querySelector('[data-prev]');
          this.nextButton = this.querySelector('[data-next]');
          this.counter = this.querySelector('[data-counter]');
          this.index = 0;

          this.previousButton?.addEventListener('click', () => {
            this.index = Math.max(0, this.index - 1);
            this.update();
          });

          this.nextButton?.addEventListener('click', () => {
            this.index = Math.min(this.slides.length - 1, this.index + 1);
            this.update();
          });

          this.update();
        }

        update() {
          if (!this.track || this.slides.length === 0) return;

          this.track.style.transform = `translateX(-${this.index * 100}%)`;

          if (this.counter) {
            this.counter.textContent = `${this.index + 1} / ${this.slides.length}`;
          }

          if (this.previousButton) {
            this.previousButton.disabled = this.index === 0;
          }

          if (this.nextButton) {
            this.nextButton.disabled = this.index === this.slides.length - 1;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homesome-track-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('homesome-track-tabs')) {
    customElements.define(
      'homesome-track-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-panel]'));
          this.message = this.querySelector('[data-track-message]');

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.selectTab(tab.dataset.tab));
          });

          this.querySelectorAll('[data-track-action]').forEach((button) => {
            button.addEventListener('click', () => {
              if (this.message) {
                this.message.hidden = false;
                this.message.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              }
            });
          });
        }

        selectTab(name) {
          this.tabs.forEach((tab) => {
            const active = tab.dataset.tab === name;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          this.panels.forEach((panel) => {
            panel.hidden = panel.dataset.panel !== name;
          });

          if (this.message) this.message.hidden = true;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
